// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1q1Kx","header":"styles_header__zmq15","button":"styles_button__2Hnhv","cancel":"styles_cancel__1DeW4"};